<!-- Copyright © 2026 Xerox Corporation. All Rights Reserved. Copyright protection claimed includes all forms and matters of copyrightable material and information now allowed by statutory or judicial law or hereinafter granted, including without limitation, material generated from the software programs which are displayed on the screen such as icons, screen display looks, etc. -->

<form #f="ngForm" (ngSubmit)="login()">
  <div class="modal-header">
    <h5 class="modal-title" [xdaTranslate]="'SDE_LOG_IN'"></h5>
  </div>
  <div class="modal-body" tabindex="-1">
    <div class="form-group">
      <input
        type="email"
        class="form-control"
        value=""
        [placeholder]="emailPlaceholder"
        [(ngModel)]="model.userEmail"
        #userEmail="ngModel"
        name="userEmail"
        [ngClass]="{ 'is-invalid': displayErrors && userEmail.invalid }"
        required />
      <input
        type="password"
        class="form-control"
        value=""
        [placeholder]="passwordPlaceholder"
        autocomplete="off"
        [(ngModel)]="model.userPassword"
        #userPassword="ngModel"
        name="userPassword"
        [ngClass]="{ 'is-invalid': displayErrors && userPassword.invalid }"
        required />
      @if (displayErrors && (userPassword.invalid || userEmail.invalid)) {
        <div class="invalid-feedback">
          @if (userPassword.errors || userEmail.errors) {
            <div [xdaTranslate]="'SDE_EMAIL_ANDOR_PASSWORD'"></div>
          }
        </div>
      }
      @if (displayErrors && loginFailed) {
        <div class="login-failed invalid-feedback">
          @if (loginFailed) {
            <div [xdaTranslate]="loginFailed"></div>
          }
        </div>
      }
    </div>
    <div class="form-group">
      <a
        href="#"
        (click)="forgotPassword()"
        [xdaTranslate]="'SDE_FORGOT_PASSWORD3'"></a>
    </div>
    @if (allowCreateAccount) {
      <div class="form-group">
        <a
          href="#"
          (click)="createAccount()"
          [xdaTranslate]="'SDE_CREATE_ACCOUNT2'"></a>
      </div>
    }
  </div>
  <div class="modal-footer">
    <div class="cb">
      <button
        type="button"
        class="xrx-btn btn-secondary"
        data-dismiss="modal"
        (click)="activeModal.dismiss()">
        <span class="btn-label" [xdaTranslate]="'SDE_CANCEL'"></span>
      </button>
    </div>
    <div class="cb">
      <button
        type="submit"
        class="xrx-btn btn-primary"
        [disabled]="attemptingLogin">
        <span class="btn-label" [xdaTranslate]="'SDE_LOG_IN'"></span>
      </button>
    </div>
  </div>
</form>
